"use strict";
/** @module General Validators */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLatinValidator = exports.isAllKeysValidator = exports.isPropValidator = exports.isPassportValidator = exports.isIdNumberValidator = exports.isSwiftCountryValidator = exports.isSwiftValidator = exports.isLanNumberValidator = exports.isIbanLengthValidator = exports.isIbanValidator = exports.isOtherThanValidator = exports.isSameAsValidator = exports.isMaxLengthValidator = exports.isMinLengthValidator = exports.isEmailValidator = exports.isNotHigherOrEqualValidator = exports.isNotHigherValidator = exports.isNotSmallerOrEqualValidator = exports.isNotSmallerValidator = exports.isPasswordValidator = exports.isPostalCodeValidator = exports.isNipValidator = exports.isSelectedValidator = exports.isNotEmptyTrimmedStringValidator = exports.isNotEmptyStringValidator = exports.isNotEmptyUnlessValidator = exports.isNotUndefinedValidator = exports.isNotNullValidator = exports.isValueValidator = void 0;

var iban_helper_1 = require("../helpers/iban-helper");

var value_of_letter_1 = __importDefault(require("../helpers/utils/value-of-letter"));

var isValueValidator = function isValueValidator(value) {
  return !!value;
};

exports.isValueValidator = isValueValidator;
/**
 * Checks if any proper value was given
 * @param {any} value - value to check.
 * @returns {boolean}
 */

var isNotNullValidator = function isNotNullValidator(value) {
  return value !== null;
};

exports.isNotNullValidator = isNotNullValidator;
/**
 * Checks if value is not null
 * @param {any} value - value to check.
 * @returns {boolean}
 */

var isNotUndefinedValidator = function isNotUndefinedValidator(value) {
  return value !== undefined;
};

exports.isNotUndefinedValidator = isNotUndefinedValidator;
/**
 * Checks if value is not undefined
 * @param {any} value - value to check.
 * @returns {boolean}
 */

var isNotEmptyUnlessValidator = function isNotEmptyUnlessValidator(value, canBeEmpty) {
  return canBeEmpty ? true : !!value;
};

exports.isNotEmptyUnlessValidator = isNotEmptyUnlessValidator;
/**
 * Checks if value was given unless can be empty.
 * @param {string} value - value to check.
 * @param {boolean} canBeEmpty - if true validation is ignored
 * @returns {boolean}
 */

var isNotEmptyStringValidator = function isNotEmptyStringValidator(value) {
  return value !== '';
};

exports.isNotEmptyStringValidator = isNotEmptyStringValidator;
/**
 * Checks if value is not empty string
 * @param {any} value - value to check.
 * @returns {boolean}
 */

var isNotEmptyTrimmedStringValidator = function isNotEmptyTrimmedStringValidator(value) {
  return value.trim() !== '';
};

exports.isNotEmptyTrimmedStringValidator = isNotEmptyTrimmedStringValidator;
/**
 * Checks if value is not empty string after trim
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isSelectedValidator = function isSelectedValidator(value) {
  return exports.isNotNullValidator(value) && exports.isNotUndefinedValidator(value) && value !== '' && value !== '?' && value !== '? string: ?' && value !== '? boolean: ?' && value !== '? undefined:undefined ?';
};

exports.isSelectedValidator = isSelectedValidator;
/**
 * Checks if any option was chosen. Created for select2 library
 * @param {(string| boolean)} value - value to check.
 * @returns {boolean}
 */

var isNipValidator = function isNipValidator(value) {
  var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  var nip = value.replace(/[\s-]|PL/g, '');

  var zip = function zip(rows) {
    return rows[0].map(function (_, c) {
      return rows.map(function (row) {
        return row[c];
      });
    });
  };

  if (nip.length === 10 && parseInt(nip, 10) > 0) {
    var zippedNip = zip([weights, nip.slice(0, 9)]);
    var sum = zippedNip.map(function (_a) {
      var weight = _a[0],
          n = _a[1];
      return weight * n;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
    return sum % 11 === parseInt(nip[9], 10);
  }

  return false;
};

exports.isNipValidator = isNipValidator;
/**
 * Checks if value is valid nip number
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isPostalCodeValidator = function isPostalCodeValidator(value, country) {
  return country === 'PL' ? !!value.match(/^\d{2}\-?\d{3}$/) && value !== '00-000' && value !== '00000' : country === 'CN' ? !!value.match(/^[0-9]{1,6}$/) : true;
};

exports.isPostalCodeValidator = isPostalCodeValidator;
/**
 * Checks if value is valid polish or chinese postal code
 * @param {string} value - value to check.
 * @param {string} country - country of postal code.
 * @returns {boolean}
 */

var isPasswordValidator = function isPasswordValidator(value) {
  return !!value.match(/^.{8,}$/);
};

exports.isPasswordValidator = isPasswordValidator;
/**
 * Checks if value is valid password with 8 signs
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isNotSmallerValidator = function isNotSmallerValidator(value, minValue) {
  return value && parseFloat(value) >= parseFloat(minValue);
};

exports.isNotSmallerValidator = isNotSmallerValidator;
/**
 * Checks if value is smaller than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */

var isNotSmallerOrEqualValidator = function isNotSmallerOrEqualValidator(value, minValue) {
  return value && parseFloat(value) > parseFloat(minValue);
};

exports.isNotSmallerOrEqualValidator = isNotSmallerOrEqualValidator;
/**
 * Checks if value is smaller or equal than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */

var isNotHigherValidator = function isNotHigherValidator(value, maxValue) {
  return value && parseFloat(value) <= parseFloat(maxValue);
};

exports.isNotHigherValidator = isNotHigherValidator;
/**
 * Checks if value is higher than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */

var isNotHigherOrEqualValidator = function isNotHigherOrEqualValidator(value, maxValue) {
  return value && parseFloat(value) < parseFloat(maxValue);
};

exports.isNotHigherOrEqualValidator = isNotHigherOrEqualValidator;
/**
 * Checks if value is higher or equal than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */

var isEmailValidator = function isEmailValidator(value) {
  return (// https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
    value ? !!value.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i) : true
  );
};

exports.isEmailValidator = isEmailValidator;
/**
 * Checks if value is valid email. Based on w3.org
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isMinLengthValidator = function isMinLengthValidator(value, minLength) {
  return value && value.length >= minLength;
};

exports.isMinLengthValidator = isMinLengthValidator;
/**
 * Checks if value has smaller or equal length than given minimal length
 * @param {string} value - value to check.
 * @param {string} minLength - minimal length.
 * @returns {boolean}
 */

var isMaxLengthValidator = function isMaxLengthValidator(value, maxLength) {
  return value && value.length <= maxLength;
};

exports.isMaxLengthValidator = isMaxLengthValidator;
/**
 * Checks if value has bigger or equal length than given maximal length
 * @param {string} value - value to check.
 * @param {string} maxLength - maximal length.
 * @returns {boolean}
 */

var isSameAsValidator = function isSameAsValidator(value, otherValue) {
  return value === otherValue;
};

exports.isSameAsValidator = isSameAsValidator;
/**
 * Checks if value is equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */

var isOtherThanValidator = function isOtherThanValidator(value, otherValue) {
  return value !== otherValue;
};

exports.isOtherThanValidator = isOtherThanValidator;
/**
 * Checks if value is not equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */

var isIbanValidator = function isIbanValidator(value, countryCode) {
  return iban_helper_1.ibanHelper.checkIban(value, countryCode);
};

exports.isIbanValidator = isIbanValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */

var isIbanLengthValidator = function isIbanLengthValidator(value, countryCode) {
  return iban_helper_1.ibanHelper.checkIbanLength(value, countryCode);
};

exports.isIbanLengthValidator = isIbanLengthValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */

var isLanNumberValidator = function isLanNumberValidator(value, country) {
  var lanCountriesRules = {
    AU: /^[A-Za-z0-9]{6,30}$/,
    CA: /^[A-Za-z0-9]{7,15}$/,
    CN: /^(?:OSA|NRA|FTN)?[A-Z0-9]{1,22}$/i,
    JP: /^[A-Za-z0-9]{8,14}$/,
    KR: /^[A-Za-z0-9]{11,16}$/,
    NZ: /^[A-Za-z0-9]{15,16}$/,
    SG: /^[A-Za-z0-9]{1,14}$/,
    TW: /^[A-Za-z0-9]{1,22}$/,
    US: /^[A-Za-z0-9]{10,30}$/
  };
  var defaultRule = /^[A-Za-z0-9]{1,22}$/;
  return !!value.replace(/ /g, '').match(lanCountriesRules[country] ? lanCountriesRules[country] : defaultRule);
};

exports.isLanNumberValidator = isLanNumberValidator;
/**
 * Checks if value is valid non-iban account number
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isSwiftValidator = function isSwiftValidator(value) {
  return !!value.match(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i);
};

exports.isSwiftValidator = isSwiftValidator;
/**
 * Checks if value is valid swift number
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isSwiftCountryValidator = function isSwiftCountryValidator(swift, country) {
  var swiftCountry = swift.substr(4, 2);
  return !country ? true : country === 'CN' ? ['CN', 'HK', 'MO'].includes(swiftCountry) : swiftCountry === country;
};

exports.isSwiftCountryValidator = isSwiftCountryValidator;
/**
 * Checks if given country is equal to country taken from swift
 * @param {string} swift - swift to check.
 * @param {string} country - country to compare.
 * @returns {boolean}
 */

var isIdNumberValidator = function isIdNumberValidator(value) {
  var idNumberWeights = [7, 3, 1, 9, 7, 3, 1, 7, 3];

  function checkIdNumber(id) {
    var controlSum = 0;

    for (var i = 0; i < id.length; i++) {
      controlSum += i < 3 ? value_of_letter_1.default(id[i]) * idNumberWeights[i] : parseInt(id[i], 10) * idNumberWeights[i];
    }

    return controlSum % 10;
  }

  function isValid(id) {
    var parsedValue = id.replace(/ /g, '');
    return checkIdNumber(parsedValue) === 0 && parsedValue.length === 9;
  }

  return isValid(value);
};

exports.isIdNumberValidator = isIdNumberValidator;
/**
 * Checks if value is valid polish id number
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isPassportValidator = function isPassportValidator(value) {
  var passportNumberWeights = [7, 3, 9, 1, 7, 3, 1, 7, 3];

  function checkPassportNumber(passport) {
    var controlSum = 0;

    for (var i = 0; i < passport.length; i++) {
      controlSum += i < 2 ? value_of_letter_1.default(passport[i]) * passportNumberWeights[i] : parseInt(passport[i], 10) * passportNumberWeights[i];
    }

    return controlSum % 10;
  }

  return checkPassportNumber(value) === 0 && value.length === 9;
};

exports.isPassportValidator = isPassportValidator;
/**
 * Checks if value is valid polish passport number
 * @param {string} value - value to check.
 * @returns {boolean}
 */

var isPropValidator = function isPropValidator(validObject) {
  return !!validObject.valid;
};

exports.isPropValidator = isPropValidator;
/**
 * Checks if given object has property valid and if it is equal to true
 * @param {{valid: boolean}} value - value to check.
 * @returns {boolean}
 */

var isAllKeysValidator = function isAllKeysValidator(object, expectedKeys) {
  return expectedKeys.every(function (val) {
    return Object.keys(object).includes(val);
  });
};

exports.isAllKeysValidator = isAllKeysValidator;
/**
 * Checks if given object has all keys
 * @param {object} object - value to check.
 * @param {string[]} expectedKeys - array of expected keys.
 * @returns {boolean}
 */

var isLatinValidator = function isLatinValidator(value) {
  return !!value.match(/^(?:[\t-\r -~\xA0-\xA9\xAB\xAC\xAE-\xB1\xB4\xB6-\xB8\xBB\xBF-\u017F\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u037E\u0384\u0385\u0387\u03F6\u0482\u055A-\u055F\u0589\u058A\u058D-\u058F\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0606-\u060F\u061B\u061E\u061F\u066A-\u066D\u06D4\u06DE\u06E9\u06FD\u06FE\u0700-\u070D\u07F6-\u07F9\u07FE\u07FF\u0830-\u083E\u085E\u0964\u0965\u0970\u09F2\u09F3\u09FA\u09FB\u09FD\u0A76\u0AF0\u0AF1\u0B70\u0BF3-\u0BFA\u0C77\u0C7F\u0C84\u0D4F\u0D79\u0DF4\u0E3F\u0E4F\u0E5A\u0E5B\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F85\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u104A-\u104F\u109E\u109F\u10FB\u1360-\u1368\u1390-\u1399\u1400\u166D\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DB\u1800-\u180A\u1940\u1944\u1945\u19DE-\u19FF\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B6A\u1B74-\u1B7C\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u1E9E\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2000-\u200A\u2010-\u2029\u202F-\u205F\u207A-\u207E\u208A-\u208E\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129-\u212B\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2775\u2794-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E52\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u303F\u309B\u309C\u30A0\u30FB\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAA77-\uAA79\uAADE\uAADF\uAAF0\uAAF1\uAB5B\uAB6A\uAB6B\uABEB\uFB29\uFBB2-\uFBC1\uFD3E\uFD3F\uFDFC\uFDFD\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD00-\uDD02\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDC77\uDC78\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEC8\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3F]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFD5-\uDFF1\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3F\uDF44\uDF45]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F[\uDC9C\uDC9F]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE8B]|\uD838[\uDD4F\uDEFF]|\uD83A[\uDD5E\uDD5F]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA])+$/i);
};

exports.isLatinValidator = isLatinValidator;
/**
 * Checks if value is in Latin alphabet
 * or matches any kind of punctuation character
 * or matches any math symbols, currency signs, dingbats, box-drawing characters, etc
 * @param {string} value - value to check.
 * @returns {boolean}
 */